import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion } from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu';
import Recorder from '../Shared/Recorder';
import Listening from '../Shared/Listening';
export default class ReadAloud extends SectionBase {

  constructor(props) {
    super(props)
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onDifficultyChange = this.onDifficultyChange.bind(this);
    this.onRecorderStop = this.onRecorderStop.bind(this);
    this.onTimeIsUp = this.onTimeIsUp.bind(this);
    this.retry = this.retry.bind(this);
  }

  state = {
    difficulty: 1,
    answer: ''
  }


  async nextQuestion() {
    console.log('nextQ');

    const step = 1;
    const { difficulty } = this.state;
    const { token } = this.props;

    const res = await fetch(`${API_URL}/readaloud/createquestion/${difficulty}`,
      { headers: { Authorization: `Token ${token}` } });
    try {
      const result = await res.json();
      const readingaloud = result[0];
      const secondsLeft = readingaloud.time_seconds;
      this.setState({ readingaloud, readingaloud_id: readingaloud.id, secondsLeft, step }, this.restartTimer);

    } catch (e) {
      console.log(e);
      console.log(res);
    }
  }


  onTimeIsUp() {
    this.setState({ step: 2 })
  }

  onRecorderStop(data){
    const { audioObjectURL, audioBlobType } = data;
    this.setState({ step: 2, audioObjectURL, audioBlobType })
  }

  onDifficultyChange(e) {
    this.setState({ difficulty: e.target.value }, this.nextQuestion);

  }


  render() {
    const { token } = this.props;

    const { readingaloud, secondsLeft, step, profile, difficulty, audioObjectURL } = this.state;

    return (
      <>
        {token!==null && readingaloud && <div className={`readaloud readaloud-step${step}`}>
          <Menu token={token}  profile={profile}onDifficultyChange={this.onDifficultyChange}></Menu>
          <Time seconds={secondsLeft}></Time>
          <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
          <div className='px-5' >
            <h1 className='text-center'> Record yourself reading the sentence below</h1>
            <div className='my-5 text-center'>
              <p className='fw-bold text-muted'>
                {readingaloud.text}
              </p>

            </div>


            <div className='text-center my-5'>
              <Recorder onStop={this.onRecorderStop} audioObjectURL={audioObjectURL} secondsLeft={secondsLeft}></Recorder>

            </div>

            {step >= 2 && <>
              <div className='result mb-2 text-center'>
                <p className='my-5'>
                You can compare your recorded answer with what the exam will expect below:

                </p>
                
                <div className='custom-box-1 shadow-lg text-center m-auto p-4 my-5' style={{maxWidth:'500px'}}>
                  <h4>Example Answer</h4>
                  <Listening file={readingaloud.file} listensremaining={null} />

                </div>

              </div>

            </>
            }



            <div className='buttons d-flex justify-content-between'>
              <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>

            </div>
            <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
            {false && <div>{JSON.stringify(this.state)}</div>}
          </div>

        </div>}

        {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

      </>

    )
  }


  retry() {
    const {readingaloud} = this.state;
    this.setState({ step: 1, secondsLeft: readingaloud.time_seconds, audioObjectURL:undefined });
    this.restartTimer();
  }

  startRecording() {

  }

  



}
